import { render, staticRenderFns } from "./ThreeColumnDetail.vue?vue&type=template&id=629eff28"
import script from "./ThreeColumnDetail.vue?vue&type=script&lang=js"
export * from "./ThreeColumnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports